import React from "react";
import Modal from './index';
import FormGroup from "../Form/FormGroup";
import Button from "../Form/Button";
import FormGroupInline from '../Form/FormGroupInline';

const ModalConfirm = ({ icon, title = "", description = "", text = "", confirmLabel = "Confirmar", confirmVariant = "primary", confirmDisabled = false, onSubmit, closeModal }) => {
    const handleCancel = (e) => {
        e.preventDefault()
        e.stopPropagation()
        closeModal()
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onSubmit()
    }

    return (
        <Modal
            icon={icon}
            title={title}
            description={description}
            closeModal={closeModal}
        >
            <form onSubmit={handleSubmit}>
                <FormGroupInline>
                    <FormGroup>
                        {text}
                    </FormGroup>
                </FormGroupInline>
                <FormGroupInline>
                    <Button variant={confirmVariant} type="submit" disabled={confirmDisabled}>{confirmLabel}</Button>
                    <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                </FormGroupInline>
            </form>
        </Modal>
    )
}

export default ModalConfirm
